module.exports = __webpack_public_path__ + "public/Icons/right-arrow.png?4f92e888";